<div id="cover" *ngIf="projectService.loading()"></div>

<div class="section-page">
  <div [ngClass]="showActionBar ? 'container' : 'container-for-form-list'">
    <div *ngIf="true">
      <form [formGroup]="dynamicForm">
        <div class="combined-card">
          <div class="filter-section">
            <label class="field-label">
              Select Form <span class="text-danger">*</span>
            </label>
            <p-select [options]="projectService.getActiveFormList()" optionLabel="form_name" optionValue="form_id"
              [formControl]="formSelectControl" (onChange)="onFormChange()" appendTo="body" [resetFilterOnHide]="true"
              placeholder="Choose a form" class="w-100">
            </p-select>
          </div>
          <div *ngIf="selected_form" class="simple-fields-section">
            <div class="simple-fields-scroll-wrapper">
              <div *ngFor="let section of formConfig?.sections">
                <div *ngIf="section.layout_type === 'Simple'">
                  <div class="fields-grid">
                    <div *ngFor="let field of section.fields" class="field">
                      <label class="label">
                        {{ field?.field_label[0]?.toUpperCase() + field?.field_label?.slice(1)?.toLowerCase() }}
                        <span *ngIf="field.is_required" class="required">*</span>
                      </label>
                      <ng-container [ngSwitch]="field.field_type.toLowerCase()">
                        <p-datepicker *ngSwitchCase="'year'" [showIcon]="true" view="year" dateFormat="yy"
                          [formControlName]="field.field_key" appendTo="body"></p-datepicker>
                        <p-datepicker *ngSwitchCase="'month'" [showIcon]="true" view="month" dateFormat="MM"
                          [formControlName]="field.field_key" appendTo="body"></p-datepicker>
                        <p-datepicker *ngSwitchCase="'date'" [showIcon]="true" dateFormat="dd"
                          [formControlName]="field.field_key" appendTo="body"></p-datepicker>
                        <p-select *ngSwitchCase="'dropdown'" [options]="getFieldOptions(field)"
                          [formControlName]="field.field_key" [filter]="true" filterBy="label"
                          placeholder="Select option" class="w-100" appendTo="body">
                        </p-select>
                        <div *ngSwitchCase="'currency'" class="currency-input">
                          <span class="currency-symbol">₹</span>
                          <input pInputText type="number" [formControlName]="field.field_key" placeholder="0.00">
                        </div>
                        <input *ngSwitchDefault pInputText [type]="field.field_type" [formControlName]="field.field_key"
                          [placeholder]="'Enter ' + field.field_label" class="w-100">
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; gap:10px" *ngIf="showActionBar">
            <button type="button" class="btn-primary-save" [disabled]="!selected_form" (click)="openExcelDialog()"
              [title]="!selected_form ? 'Please Select a Form to Download Excel Template' : 'Click to Download Excel Template'">
              <i class="fa-solid fa-download"></i>Excel Formate
            </button>
            <button type="button" class="btn-primary-save" [disabled]="!selected_form" (click)="uploadExcelData()"
              [title]="!selected_form ? 'Please Select a Form to Upload Form Data in Excel Format' : 'Click to Upload Form Data in Excel Format'">
              <i class="fa-solid fa-upload"></i>Upload Excel
            </button>
          </div>
          <input id="excelFileInput" type="file" accept=".xlsx,.xls" style="display: none;"
            (change)="onExcelFileSelected($event)" />
        </div>

        <div class="period-tabs" *ngIf="importedPeriods.length > 1">
          <button type="button" *ngFor="let p of importedPeriods; let i = index" class="tab-btn"
            [class.active]="i === activePeriodIndex" (click)="switchPeriod(i)">
            {{ p.label }}
          </button>
        </div>

        <div *ngIf="matrixSections.length > 0" [ngClass]="importedPeriods.length > 1 ? 'matrix-card-with-multi' : showActionBar ? 'matrix-card' : 'matrix-card-for-list'">
          <div class="tabs-container">
            <div class="tabs-header">
              <button *ngFor="let section of matrixSections; let i = index" type="button" class="tab-btn"
                [class.active]="activeSection === section.section_name" (click)="setActiveTab(i, section.section_name)">
                {{ section?.section_name[0]?.toUpperCase() + section?.section_name?.slice(1)?.toLowerCase() }}
              </button>
            </div>

            <div class="tabs-content">
              <div *ngFor="let section of formConfig?.sections; let j = index" class="tab-pane"
                [class.active]="activeSection === section.section_name">
                <div *ngIf="section.layout_type === 'Matrix'" class="matrix-container">
                  <div [formArrayName]="section.section_name"
                    [ngClass]="showActionBar ? 'table-scroll' : 'table-scrolls-from-form-list-page' ">
                    <table class="matrix-table">
                      <thead>
                        <tr>
                          <th class="sticky">{{ section?.section_name[0]?.toUpperCase() +
                            section?.section_name?.slice(1)?.toLowerCase() }}</th>
                          <th *ngFor="let field of section.fields">{{ field?.field_label[0]?.toUpperCase() +
                            field?.field_label?.slice(1)?.toLowerCase() }}</th>
                          <th *ngIf="hasRemarkColumn(section)">Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of getMatrix(section.section_name).controls; let i = index"
                          [formGroupName]="i">
                          <td style="width: 30% !important;">
                            <ng-container
                              *ngIf="getSubMasterOptions(section?.matrix_rows[i], j, i, section?.section_name)?.length > 0; else plainText">
                              <div class="master-data-container">
                                <div class="master-name">{{ section?.matrix_rows[i]?.master_value_name }}</div>
                                <p-multiSelect [formControlName]="'sub_master_values'"
                                  [options]="getSubMasterOptions(section?.matrix_rows[i], j, i, section?.section_name)"
                                  optionLabel="sub_master_value_name" optionValue="sub_master_value_id"
                                  placeholder="Select options" class="w-100" appendTo="body" [showToggleAll]="true">
                                </p-multiSelect>
                              </div>
                            </ng-container>
                            <ng-template #plainText>
                              <div class="master-name">{{ section?.matrix_rows[i]?.master_value_name }}</div>
                            </ng-template>
                          </td>
                          <td *ngFor="let field of section.fields" style="width: 15% !important;">
                            <div *ngIf="field.field_type === 'currency'" class="currency-input">
                              <span class="currency-symbol">₹</span>
                              <input pInputText type="number" [formControlName]="field.field_key" placeholder="0">
                            </div>
                            <input *ngIf="field.field_type !== 'currency'" pInputText [type]="field.field_type"
                              [formControlName]="field.field_key" placeholder="">
                          </td>
                          <td *ngIf="section.matrix_rows[i]?.is_remark">
                            <input pInputText type="text" formControlName="remark" placeholder="Remarks" class="w-100">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="action-bar" *ngIf="showActionBar">
          <button type="button" class="btn-secondary" (click)="resetForm()"><i class="fa fa-refresh"></i>Reset</button>
          <button type="button" class="btn-secondary" (click)="moveBack()" *ngIf="activeTabIndex > 0"><i
              class="fa fa-backward"></i>Back</button>
          <button type="button" class="btn-secondary" (click)="saveNext()"
            *ngIf="activeTabIndex < matrixSections.length - 1"><i class="fa fa-forward"></i>Next</button>

          <button type="button" class="btn-primary-save" *ngIf="importedPeriods.length > 1"
            [disabled]="!selected_form" (click)="saveAllPeriods()">
            <i class="fa fa-save"></i>Save All ({{ importedPeriods.length }})
          </button>
          <button type="button" class="btn-primary-save" *ngIf="importedPeriods.length <= 1"
            [disabled]="dynamicForm.invalid || !selected_form" (click)="submitForm()">
            <i class="fa fa-save"></i>Save Form
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
  [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
  <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
    [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
  <span>{{ commonDataObject.apiMeassge }}</span>
  <i class="fas fa-times close-alert"
    (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>

<p-dialog header="Excel Template Options" [(visible)]="showExcelDialog" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '560px' }" [breakpoints]="{ '640px': '92vw' }"
  styleClass="excel-options-dialog" appendTo="body">

  <div class="excel-options-body">

    <div class="excel-option-field" *ngIf="excelDateOrMonthOrYearHas?.hasYear">
      <label class="label">Select Years <span class="required">*</span></label>
      <p-multiSelect class="excel-full-select" [options]="yearOptions" [(ngModel)]="selectedExcelYears"
        [ngModelOptions]="{ standalone: true }" optionLabel="label" optionValue="value" display="comma"
        [maxSelectedLabels]="4" selectedItemsLabel="{0} years selected" placeholder="Select years"
        [filter]="true" filterBy="label" [showToggleAll]="true" [showClear]="true" appendTo="body"
        panelStyleClass="excel-select-panel" (onChange)="onExcelYearsChange()" (onClear)="onExcelYearsChange()"
        style="display: flex !important;">
      </p-multiSelect>
    </div>

    <ng-container *ngIf="excelDateOrMonthOrYearHas?.hasMonth">
      <ng-container *ngIf="excelDateOrMonthOrYearHas?.hasYear; else monthsOnly">
        <div class="excel-year-month-list" *ngIf="selectedExcelYears.length > 0">
          <div class="excel-year-month-header">
            <span class="excel-year-col">Year</span>
            <span class="excel-month-col">Months <span class="required">*</span>
              <small class="excel-date-hint" *ngIf="excelDateOrMonthOrYearHas?.hasDate">
                (then pick the dates for each month)</small>
            </span>
          </div>
          <div class="excel-year-block" *ngFor="let y of selectedExcelYears; trackBy: trackByYear">
            <div class="excel-year-month-item">
              <span class="excel-year-col excel-year-label">{{ y }}</span>
              <p-multiSelect class="excel-month-col excel-full-select" panelStyleClass="excel-select-panel"
                [options]="monthOptions" [(ngModel)]="excelYearMonths[y]" [ngModelOptions]="{ standalone: true }"
                optionLabel="label" optionValue="value" display="comma" [maxSelectedLabels]="2"
                selectedItemsLabel="{0} months selected" [placeholder]="'Select months for ' + y"
                [showToggleAll]="true" appendTo="body" (onChange)="onExcelMonthsChange()" style="display: flex !important;">
              </p-multiSelect>
            </div>

            <div class="excel-date-grid" *ngIf="excelDateOrMonthOrYearHas?.hasDate && excelYearMonths[y]?.length">
              <div class="excel-date-cell" *ngFor="let m of getSelectedMonths(y); trackBy: trackByMonth">
                <span class="excel-date-cell-label" [title]="m.label + ' ' + y">{{ m.label.slice(0, 3) }}</span>
                <p-multiSelect class="excel-date-select" panelStyleClass="excel-select-panel"
                  [options]="getDateOptions(y, m.value)" [ngModel]="getMonthDates(y, m.value)"
                  (ngModelChange)="setMonthDates(y, m.value, $event)" [ngModelOptions]="{ standalone: true }"
                  optionLabel="label" optionValue="value" display="comma" [maxSelectedLabels]="3"
                  selectedItemsLabel="{0} dates selected" placeholder="Select dates" [showToggleAll]="true"
                  appendTo="body">
                </p-multiSelect>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #monthsOnly>
        <div class="excel-option-field">
          <label class="label">Select Months <span class="required">*</span></label>
          <p-multiSelect [options]="monthOptions" [(ngModel)]="excelYearMonths[NO_YEAR_KEY]"
            [ngModelOptions]="{ standalone: true }" optionLabel="label" optionValue="value" display="comma"
            [maxSelectedLabels]="2" selectedItemsLabel="{0} months selected" placeholder="Select months"
            [showToggleAll]="true" appendTo="body" class="excel-full-select" panelStyleClass="excel-select-panel"
            (onChange)="onExcelMonthsChange()" style="display: flex !important;">
          </p-multiSelect>

          <div class="excel-date-grid" *ngIf="excelDateOrMonthOrYearHas?.hasDate && excelYearMonths[NO_YEAR_KEY]?.length">
            <div class="excel-date-cell" *ngFor="let m of getSelectedMonths(NO_YEAR_KEY); trackBy: trackByMonth">
              <span class="excel-date-cell-label" [title]="m.label">{{ m.label.slice(0, 3) }}</span>
              <p-multiSelect class="excel-date-select" panelStyleClass="excel-select-panel"
                [options]="getDateOptions(NO_YEAR_KEY, m.value)" [ngModel]="getMonthDates(NO_YEAR_KEY, m.value)"
                (ngModelChange)="setMonthDates(NO_YEAR_KEY, m.value, $event)" [ngModelOptions]="{ standalone: true }"
                optionLabel="label" optionValue="value" display="comma" [maxSelectedLabels]="3"
                selectedItemsLabel="{0} dates selected" placeholder="Select dates" [showToggleAll]="true"
                appendTo="body" style="display:  flex !important;">
              </p-multiSelect>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <div class="excel-date-option" *ngIf="excelDateOrMonthOrYearHas?.hasDate">
      <input id="excelIncludeDate" type="checkbox" [checked]="true" disabled />
      <label for="excelIncludeDate" class="label">Date</label>
    </div>

    <small class="excel-options-error" *ngIf="excelOptionsError">{{ excelOptionsError }}</small>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn-secondary" (click)="closeExcelDialog()">Cancel</button>
    <button type="button" class="btn-primary-save" (click)="confirmExcelExport()">
      <i class="fa-solid fa-download"></i>Download
    </button>
  </ng-template>
</p-dialog>

<p-dialog header="Excel Import Issues" [(visible)]="showIssuesDialog" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '520px' }" [breakpoints]="{ '640px': '92vw' }" styleClass="excel-issues-dialog"
  appendTo="body">

  <div class="excel-issues-body">
    <div *ngFor="let issue of excelImportIssues" class="excel-issue" [ngClass]="{
        'is-error':   issue.severity === 'error',
        'is-warning': issue.severity === 'warning',
        'is-info':    issue.severity === 'info'
      }">
      <span class="excel-issue-icon">
        <i class="fas" [class.fa-times-circle]="issue.severity === 'error'"
          [class.fa-exclamation-circle]="issue.severity === 'warning'"
          [class.fa-info-circle]="issue.severity === 'info'"></i>
      </span>
      <span class="excel-issue-msg">{{ issue.message }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn-secondary" (click)="closeIssuesDialog()">
      Ok
    </button>
  </ng-template>
</p-dialog>